'use strict'

module.exports = {
    videoPosterPrefix: '', // video poster not in use (deprecated)
    videoSrcPrefix: 'addPanelData/sections/videos_en/maskedVideobox/videobox-thumb-'
}
